"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

var _locales = require("../data/locales.json");

var _locales2 = _interopRequireDefault(_locales);

var _numericFormat = require("../data/numericFormat.json");

var _numericFormat2 = _interopRequireDefault(_numericFormat);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

exports.default = function (dirtyLanguage) {
  var result = {};
  var keys = Object.keys(_locales2.default);
  var language = !dirtyLanguage || typeof dirtyLanguage !== 'string' ? '' : dirtyLanguage.toLowerCase();

  for (var i = 0; i < keys.length; i += 1) {
    var key = keys[i];
    var locale = _locales2.default[key];
    result[key] = _extends({}, locale, {
      numericFormat: _numericFormat2.default[locale.numericFormat]
    });
  }

  if (!language) {
    return result;
  }

  if (result[language]) {
    return result[language];
  }

  console.warn(language + " is not supported by Arena locales, returning en-US.");
  return result['en-us'];
};